import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiRequests } from '../../shared/api/apiRequests.js';
import { LanguageOptions } from '../../entities/LanguageOptions/index.js';
import { toast } from 'react-toastify';
import { UploadIcon } from '../../features/UploadIcon';
import { Form, Row, Col } from 'react-bootstrap';
import { FormLayout, FormSection, FormField } from '../../shared/ui/FormLayout';

const CreateLanguagePage = () => {
  const [icon, setIcon] = useState(null);
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();
  const [form, setForm] = useState({
    title: '',
    isHidden: false,
    isRightToLeft: false,
    code: '',
    mainLanguageId: 1,
  });

  const handleRequest = async () => {
    if (!form.title.trim()) {
      toast.error('Введите название языка');
      return;
    }
    if (!form.code.trim()) {
      toast.error('Введите код языка');
      return;
    }

    setSaving(true);
    try {
      const body = new FormData();
      if (icon) {
        body.append('mainImg', icon);
      }
      body.append('model', JSON.stringify(form));

      await apiRequests.languages.create(body);
      toast.success('Язык успешно создан');
      navigate('/languages');
    } catch (e) {
      toast.error('Произошла ошибка');
    } finally {
      setSaving(false);
    }
  };

  return (
    <FormLayout
      onSubmit={handleRequest}
      onBack={() => navigate('/languages')}
      saving={saving}
      submitText="Создать"
      savingText="Создание..."
    >
      <FormSection title="Основная информация">
        <Row>
          <Col md={6}>
            <FormField label="Название" required>
              <Form.Control
                type="text"
                value={form.title}
                onChange={(e) => setForm((prev) => ({ ...prev, title: e.target.value }))}
                placeholder="Введите название языка"
              />
            </FormField>
          </Col>
          <Col md={3}>
            <FormField label="Код языка" required>
              <Form.Control
                type="text"
                value={form.code}
                onChange={(e) => setForm((prev) => ({ ...prev, code: e.target.value }))}
                placeholder="ru, en, kz"
              />
            </FormField>
          </Col>
          <Col md={3}>
            <FormField label="Справа налево">
              <Form.Select
                value={form.isRightToLeft}
                onChange={(e) => setForm((prev) => ({ ...prev, isRightToLeft: e.target.value === 'true' }))}
              >
                <option value="false">Нет</option>
                <option value="true">Да</option>
              </Form.Select>
            </FormField>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <LanguageOptions
              label="Основной язык"
              onSelect={(val) => setForm((prev) => ({ ...prev, mainLanguageId: val }))}
            />
          </Col>
          <Col md={6}>
            <FormField label="Иконка">
              <UploadIcon onSelect={setIcon} entityType="language" />
            </FormField>
          </Col>
        </Row>
      </FormSection>
    </FormLayout>
  );
};

export default CreateLanguagePage;
